import { z } from 'zod';
import { aspectRationImagePosition } from '@ag1/ui';

export const rawImage = z.object({
  _type: z.string(),
  asset: z.object({
    _type: z.string(),
    _ref: z.string()
  }),
  alt: z.string().optional().default(''),
  fit: z
    .union([z.literal('cover'), z.literal('contain'), z.literal('adaptive')])
    .default('adaptive')
    .optional(),
  position: aspectRationImagePosition.optional(),
  crop: z
    .object({
      _type: z.literal('sanity.imageCrop'),
      bottom: z.number(),
      left: z.number(),
      right: z.number(),
      top: z.number()
    })
    .optional(),
  hotspot: z
    .object({
      _type: z.literal('sanity.imageHotspot'),
      height: z.number(),
      width: z.number(),
      x: z.number(),
      y: z.number()
    })
    .optional()
});

export type RawImage = z.infer<typeof rawImage>;

export type SanityHotspotImage = Omit<RawImage, '_type' | 'asset'> & { url: string; ext: string };
